import { render, staticRenderFns } from "./MetricsTotalSaving.vue?vue&type=template&id=14b578c4"
import script from "./MetricsTotalSaving.vue?vue&type=script&lang=js"
export * from "./MetricsTotalSaving.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports